angular.module('agreements')
    .component('agreementStatusLabel', {
        bindings: {
            status: '<'
        },
        template: `
            <span class="label label-default agreement-status {{$ctrl.status}}" ng-if="$ctrl.status != null">{{ 'agreement.status.'.concat($ctrl.status) | translate }}</span>
        `
    })
